import React from 'react';

/**
 * Reusable Order Step Component
 * 
 * @param {object} props
 * @param {string} props.title - The title/heading for the step
 * @param {React.ReactNode} props.children - The content of the step
 * @param {string} [props.className] - Additional CSS classes
 */
const OrderStep = ({ title, children, className = '' }) => {
  return (
    <div className={`order-section mt-20 step-content ${className}`}>
      <h2 className='section-title'>{title}</h2>
      {children}
    </div>
  );
};

export default OrderStep;
